import angular from "angular";
import {formatLocationMethod} from './location-method-format';

angular
    .module('ui-common')
    .filter('locationMethod', LocationMethodFilter);

function LocationMethodFilter() {
    return function (locationMethod, latitude, longitude, noLocationReason) {
        return formatLocationMethod(locationMethod, noLocationReason);
    };
}
